export default "__VITE_ASSET__h0H1wbTu__"